import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import Index from "@/pages/Index";
export const Route = createFileRoute("/dashboard")({ head: ({match}) => pageHead(match.pathname), component: () => (<ProtectedRoute><Index /></ProtectedRoute>) });
